import React, { useContext } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material";
import SettingsMenu from "./SettingsMenu";
import TicketNavigator from "./TicketNavigator";
import ConnectionMonitor from "./ConnectionMonitor";
import { GlobalContext } from "../Utils/Contexts";
import { styled } from "@mui/system";
import { SyncStatus } from "../Utils/Interfaces";

interface TicketAppBarProps {
    setAuthorizationToken(newToken: string | null): void;
    showForceReloadDialogue(): void;
}

export default function TicketAppBar(props: TicketAppBarProps): JSX.Element {
    const context = useContext(GlobalContext);
    const theme = useTheme();

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const Offset = styled("div")(({ theme }) => theme.mixins.toolbar);

    return (
        <Box sx={{ flexGrow: 1 }}>
            <AppBar position="fixed">
                <Toolbar>
                    {context.syncStatus !== SyncStatus.Loading && <TicketNavigator />}
                    <Typography component="div" sx={{ flexGrow: 1 }} />
                    <ConnectionMonitor />
                    <SettingsMenu setAuthorizationToken={props.setAuthorizationToken} showForceReloadDialogue={props.showForceReloadDialogue}></SettingsMenu>
                </Toolbar>
            </AppBar>
            <Offset />
        </Box>
    );
}
